/**
 * Root Reducer
 *
 * @author edmsamuel
 */
import { combineReducers } from 'redux'
import { connectRouter } from 'connected-react-router'
import { createBrowserHistory as createHistory } from 'history'
import { themeReducer as theme } from './kernel.theme'
import cuenta from './cuenta'

export const history = createHistory()
const rootReducer = combineReducers({
  router: connectRouter(history),
  theme,
  cuenta,
})

export default rootReducer
